<template>
  <v-container fluid>
    <v-card class="elevation-1">
      <v-toolbar flat>
        <v-toolbar-title class="headline">
          <v-icon left>fab fa-fedex</v-icon>
          Shipping Requests and Fufillments
        </v-toolbar-title>
        <template v-slot:extension>
          <v-switch v-model="getAll" label="Get All" />
          <v-spacer />
          <v-text-field
            hide-details
            single-line
            prepend-icon="search"
            v-model="search"
          />
        </template>
        <v-spacer />
        <ShippingForm :is-edit="false" :userLoading="userLoading"/>
        <v-btn @click="initialize" icon><v-icon>refresh</v-icon></v-btn>
      </v-toolbar>
      <ShippingTable :shipments="shipments" :loading="loading" :search="search" :user-loading="userLoading"/>
    </v-card>
  </v-container>
</template>

<script>
import { Shipping } from "../../models/Shipping";
import ShippingTable from "../../components/Shipping/ShippingTable";
import ShippingForm from "../../components/Shipping/ShippingForm";
import User from "../../models/User";
export default {
  name: "Shipping",
  components: { ShippingTable, ShippingForm },
  data() {
    return {
      loading: true,
      search: "",
      getAll: false,
      userLoading: true
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    shipments() {
      if (this.getAll) {
        return Shipping.query()
          .withAll()
          .get();
      } else {
        return Shipping.query()
          .withAll()
          .where("state", "Requested")
          .get();
      }
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      this.userLoading = true;
      Shipping.$fetch().then(() => (this.loading = false));
      User.$fetch().then(() => (this.userLoading = false));
    }
  }
};
</script>
